import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useAuth } from "../auth/AuthProvider";
import { InviteScreen } from "../invite/InviteScreen";

export const Route = createFileRoute("/invite/$token")({ component: InviteRoute });

// The token stays in the address bar, deliberately. An earlier version stripped it with
// window.history.replaceState on mount; that broke the page outright, because TanStack
// Router's createBrowserHistory patches replaceState, so the call notified the router, which
// re-matched the location "/invite" — a route that does not exist — and rendered "Not Found".
//
// Leaving it is the right answer anyway: the invitation IS a link, so the token is in the URL
// the moment the invitee clicks it, and no in-page trick changes how it arrived. What actually
// matters is kept: the token never appears in a request URL (both calls POST it in the body,
// so it stays out of access logs and Sentry's endpoint tag), and sentry.ts's scrubInviteTokens
// redacts it from the page URL that @sentry/react attaches to every event.
function InviteRoute() {
  const { token } = Route.useParams();
  const auth = useAuth();
  const navigate = useNavigate();

  return <InviteScreen token={token} auth={auth} onJoined={() => void navigate({ to: "/" })} />;
}
